import { TENURE_DATA, TENURE_ERROR_DATA, TENURE_HIDE_ERROR_DATA, TENURE_START_LOADER, TENURE_STOP_LOADER, } from "../interface/iTenureDetails";
const initialState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const tenure = (state = initialState, action) => {
    switch (action.type) {
        case TENURE_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case TENURE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case TENURE_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case TENURE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case TENURE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default tenure;
